(() => {
  angular
    .module('app.report')
    .controller('ExportModalController', ExportModal);

  ExportModal.$inject = [
    '$cookies',
    'pid',
    'close',
    'campaign',
    'ExportService',
  ];

  function ExportModal(
    $cookies,
    pid,
    close,
    campaign,
    ExportService,
  ) {
    const vm = this;
    vm.includeDelivery = angular.isUndefined($cookies.getObject('includeDelivery')) ?
      false : $cookies.getObject('includeDelivery');
    vm.campaign = {
      name: campaign.name,
    };

    vm.isStandard = () => campaign && campaign.type === 'standard';

    vm.requestExport = documentType => {
      var engine = campaign.type === 'integrated' && documentType === 'pdf' ?
        'chromium' :
        'docraptor';

      ExportService.exportDocument(pid, campaign.name, documentType, vm.includeDelivery, engine);
    };

    vm.switchDelivery = function () {
      vm.includeDelivery = !vm.includeDelivery;
      $cookies.putObject('includeDelivery', vm.includeDelivery);
    }
  }
})();
